import { createSlice } from '@reduxjs/toolkit';
import * as reducers from './reducers';
import { Member } from '../../../types';
import { extraReducers } from './extraReducers';

export type State = Member;

const initialState = null! as State;

export const memberSlice = createSlice({
  name: 'member',
  initialState,
  reducers,
  extraReducers,
});
